module.exports = __webpack_public_path__ + "static/media/about-reviewdale.a0148bca.svg";